import { action, payload } from 'ts-action'
import { IShift } from '@network/models/shift.model'
import { IModalDuplicateShiftValues } from 'helpers/shiftHelpers/types'

export const SaveDuplicateValues = action(
  'SaveDuplicateValues',
  payload<IModalDuplicateShiftValues>(),
)

export const SaveShift = action('SaveShift', payload<IShift>())

export const ClearDuplicateValues = action('ClearDuplicateValues')

export const ClearShift = action('ClearShift')
